import EntityState from '@/data/EntityState';
import type { EntityMap } from '@/data/types';
import type { RipplingPayrollRun } from '@/integrations/modules/rippling/store/payrollRun/model';

export default class RipplingPayrollRunsState extends EntityState<RipplingPayrollRun> {
  declare readonly items: EntityMap<RipplingPayrollRun>;
}
